import React from "react";
import { InView } from 'react-intersection-observer'; // Import Intersection Observer

const Vision = () => {
  return (
    <div className="py-8"> {/* Reduced padding */}
      <div className="container mx-auto px-6 flex flex-col lg:flex-row items-center">
        {/* Left Section - Content */}
        <InView
          triggerOnce={true}  // Trigger animation once when element comes into view
          threshold={0.5}      // Trigger when 50% of the element is visible
        >
          {({ inView, ref }) => (
            <div
              ref={ref}
              className={`lg:w-1/2 text-left lg:text-left mb-4 lg:mb-0 transform transition-transform ${inView ? 'animate__animated animate__fadeInLeft' : ''}`}
            >
              <h2 className="text-3xl font-bold text-gray-800 mb-2">Our Vision</h2> {/* Reduced font size and margin */}
              <p className="text-lg text-gray-600 mb-2"> {/* Reduced margin */}
                At EDIT EZY, our vision is to empower individuals, businesses, and educational institutions by providing them with an intuitive, simple-to-use platform to create stunning posters, business cards, and marketing materials.
                <br /><br />
                We aim to break down barriers to creativity by enabling users with no design experience to create high-quality visuals quickly and efficiently. Our goal is to revolutionize the way posters and promotional materials are created, allowing everyone to express their ideas visually with ease.
                <br /><br />
                Through our platform, we envision a future where anyone can design, share, and print professional-quality materials with a few simple clicks, helping to elevate personal projects, educational events, and business promotions.
              </p>
            </div>
          )}
        </InView>

        {/* Right Section - Image */}
        <InView
          triggerOnce={true}  // Trigger animation once when element comes into view
          threshold={0.5}      // Trigger when 50% of the element is visible
        >
          {({ inView, ref }) => (
            <div
              ref={ref}
              className={`lg:w-1/2 flex justify-center transform transition-transform ${inView ? 'animate__animated animate__fadeInRight' : ''}`}
            >
              <img
                src="https://static.vecteezy.com/system/resources/previews/010/902/081/large_2x/business-analytics-in-cloud-arrow-leadership-company-people-challenge-teamwork-up-flat-job-marketing-concept-illustration-growth-with-rocket-investment-service-man-and-woman-trend-result-vector.jpg"
                alt="Our Vision"
                className="w-full sm:w-[280px] md:w-[350px] lg:w-[500px] h-auto object-cover" // Adjust width and height for different screens
              />
            </div>
          )}
        </InView>
      </div>
    </div>
  );
};

export default Vision;
